import { useState, useEffect } from "react";
import AdminLayout from "../components/AdminLayout";
import axiosInstance from "../axiosInstance";
import { API_URL_All } from "../api";
import { toast } from "react-toastify";
import { fetchSettingsPermissions } from "../libs/customerCreatePermission";

const LINES = [
  { id: "1", name: "TMĐT" },
  { id: "4", name: "Line thường" },
  { id: "11", name: "Line XT" },
  { id: "12", name: "Line VAT" },
];

const STATUSES = [
  { key: "3", label: "Đơn mới" },
  { key: "6", label: "Kho TQ" },
  { key: "7", label: "Xe về VN" },
  { key: "8", label: "Kho VN" },
  { key: "9", label: "Đang giao" },
  { key: "10", label: "Đã nhận" },
];

const getDefaultRows = () =>
  LINES.map((line) => ({
    ...line,
    thresholds: STATUSES.reduce(
      (acc, status) => ({ ...acc, [status.key]: "" }),
      {}
    ),
    configIds: STATUSES.reduce(
      (acc, status) => ({ ...acc, [status.key]: null }),
      {}
    ),
  }));

const OrderProcessWarningConfig = () => {
  const [rows, setRows] = useState(getDefaultRows);
  const [loading, setLoading] = useState(true);
  const [settingsPerm, setSettingsPerm] = useState({
    loaded: false,
    canView: false,
    canEdit: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchSettingsPermissions(axiosInstance);
      if (cancelled) return;
      setSettingsPerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canEdit: Boolean(p?.canEdit),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!settingsPerm.loaded || !settingsPerm.canView) return;
    fetchOrderProcessConfig();
  }, [settingsPerm.loaded, settingsPerm.canView]);

  useEffect(() => {
    console.log(rows);
    
  }, [rows]);

  const fetchOrderProcessConfig = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`${API_URL_All}/api/order-process-config`);
      const configs = response.data;

      // Transform flat array to rows structure
      const transformedRows = LINES.map((line) => {
        const lineConfigs = configs.filter(
          (config) => config.orderLineId === Number(line.id)
        );

        const thresholds = STATUSES.reduce((acc, status) => {
          const foundConfig = lineConfigs.find(
            (config) => config.orderProcessId === Number(status.key)
          );
          return {
            ...acc,
            [status.key]: foundConfig ? foundConfig.limitCount : "",
          };
        }, {});

        const configIds = STATUSES.reduce((acc, status) => {
          const foundConfig = lineConfigs.find(
            (config) => config.orderProcessId === Number(status.key)
          );
          return {
            ...acc,
            [status.key]: foundConfig ? foundConfig.id : null,
          };
        }, {});

        return {
          ...line,
          thresholds,
          configIds,
        };
      });

      setRows(transformedRows);
    } catch (error) {
      console.error("Error fetching order process config", error);
      toast.error("Lỗi khi tải cấu hình");
      setRows(getDefaultRows());
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (lineId, statusKey, value) => {
    setRows((prev) =>
      prev.map((row) =>
        row.id === lineId
          ? {
              ...row,
              thresholds: {
                ...row.thresholds,
                [statusKey]: value === "" ? "" : Number(value),
              },
            }
          : row
      )
    );
  };

  const handleReset = () => {
    if (!settingsPerm.canEdit) return;
    setRows(getDefaultRows());
  };

  const handleSave = async () => {
    if (!settingsPerm.canEdit) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    const payload = rows.flatMap((row) =>
      STATUSES.map((status) => ({
        id: row.configIds?.[status.key] || undefined,
        orderLineId: Number(row.id),
        orderProcessId: Number(status.key),
        limitCount: row.thresholds[status.key] === "" ? 0 : Number(row.thresholds[status.key]),
      }))
    );

    try {
      await axiosInstance.post(`${API_URL_All}/api/order-process-config`, payload);
      toast.success("Lưu cấu hình thành công");
      fetchOrderProcessConfig(); // Reload data after save
    } catch (error) {
      toast.error("Lỗi khi lưu cấu hình");
      console.error("Error saving order process warning config", error);
    }
  };

  return (
    <AdminLayout>
      {settingsPerm.loaded && !settingsPerm.canView ? (
        <div className="container-fluid p-3 p-md-4">
          <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
        </div>
      ) : (
      <>
      <div className="right_col" role="main">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="x_panel">
              <div className="x_title">
                <h2 className="fw-bold">Lưu trình</h2>
                <ul className="nav navbar-right panel_toolbox"></ul>
                <div className="clearfix"></div>
              </div>
              <div className="x_content  calc-200">
                <form
                  id="form_colors"
                  className=""
                  action=""
                  method="post"
                  noValidate
                >
                  <div className="table-s ">
                    <table>
                      <tbody>
                        <tr>
                          <th className="w-25">Line</th>
                          {STATUSES.map((status) => (
                            <th key={status.key}>{status.label}</th>
                          ))}
                        </tr>
                        {loading ? (
                          <tr>
                            <td colSpan={STATUSES.length + 1} className="text-center">
                              Đang tải dữ liệu...
                            </td>
                          </tr>
                        ) : (
                          rows.map((row) => (
                            <tr key={row.id}>
                              <td className="w-25">{row.name}</td>
                              {STATUSES.map((status) => (
                                <td key={status.key} className="text-center">
                                  <input
                                    className="form-control"
                                    type="number"
                                    min={0}
                                    value={row.thresholds[status.key]}
                                    readOnly={!settingsPerm.canEdit}
                                    onChange={(e) =>
                                      handleChange(row.id, status.key, e.target.value)
                                    }
                                  />
                                </td>
                              ))}
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="small fst-italic">
                    <span>
                      Thời hạn: Là số ngày được phép của một trạng thái đơn
                      hàng. Vượt thời hạn này hệ thống sẽ cảnh báo
                    </span>
                  </div>
                  <div className="ln_solid1">
                    <div className="form-group">
                      <div className="col-12 text-center">
                        <button
                          type="button"
                          className="btn-s btn btn-success"
                          onClick={handleReset}
                          disabled={!settingsPerm.canEdit}
                        >
                          Hủy
                        </button>
                        <button
                          type="button"
                          className="btn-s btn btn-primary"
                          onClick={handleSave}
                          disabled={!settingsPerm.canEdit}
                        >
                          Lưu
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
      )}
    </AdminLayout>
  );
};

export default OrderProcessWarningConfig;
